import {createContext, Dispatch, PropsWithChildren, SetStateAction, useContext} from 'react';

import {PageFilter} from 'filters/types';

type FilterState = {
  filter: PageFilter;
  setFilter: Dispatch<SetStateAction<PageFilter>>;
  isDirty: boolean;
};

const EditedFilterContext = createContext<FilterState>(null as never);

export const useEditedFilterContext = () => {
  const context = useContext(EditedFilterContext);

  if (!context) {
    throw new Error('useEditedFilterContext must be used within a EditedFilterProvider');
  }

  return context;
};

export const EditedFilterProvider = ({children, filter, setFilter, isDirty}: PropsWithChildren<FilterState>) => {
  return <EditedFilterContext.Provider value={{filter, setFilter, isDirty}}>{children}</EditedFilterContext.Provider>;
};
